/* v18: any "Message us in chat" text, [data-open-chat], [data-ctf-open-chat] or href="#chat" opens Shopify Inbox */
(function(){
  function openChat(e){
    if(e){e.preventDefault();}
    var c=document.querySelector('shopify-chat');
    if(c&&typeof c.show==='function'){c.show();return;}
    var t=0,iv=setInterval(function(){var c=document.querySelector('shopify-chat');if(c&&typeof c.show==='function'){clearInterval(iv);c.show();}else if(++t>20){clearInterval(iv);}},250);
  }
  var RX=/message us in chat/i;
  function wrapText(root){
    var w=document.createTreeWalker(root,NodeFilter.SHOW_TEXT,{acceptNode:function(n){
      if(!RX.test(n.nodeValue))return NodeFilter.FILTER_REJECT;
      var p=n.parentElement;if(!p||p.closest('a,button,script,style,textarea,input,select,shopify-chat,[data-open-chat],[data-ctf-open-chat]'))return NodeFilter.FILTER_REJECT;
      return NodeFilter.FILTER_ACCEPT;}});
    var list=[],n;while((n=w.nextNode()))list.push(n);
    list.forEach(function(t){
      var m=t.nodeValue.match(RX);if(!m)return;
      var after=t.splitText(m.index);after.splitText(m[0].length);
      var a=document.createElement('a');a.href='#chat';a.setAttribute('data-open-chat','');a.className='ctf-chat-link';a.textContent=after.nodeValue;
      after.parentNode.replaceChild(a,after);
    });
  }

  var EM=/[\w.+-]+@[\w-]+(?:\.[\w-]+)+/;
  function wrapEmails(root){
    var w=document.createTreeWalker(root,NodeFilter.SHOW_TEXT,{acceptNode:function(n){
      if(!EM.test(n.nodeValue))return NodeFilter.FILTER_REJECT;
      var p=n.parentElement;if(!p||p.closest('a,button,script,style,textarea,input,select,option,shopify-chat,[contenteditable]'))return NodeFilter.FILTER_REJECT;
      return NodeFilter.FILTER_ACCEPT;}});
    var list=[],n;while((n=w.nextNode()))list.push(n);
    list.forEach(function(t){var m;while(t&&(m=t.nodeValue.match(EM))){var a2=t.splitText(m.index);var rest=a2.splitText(m[0].length);var a=document.createElement('a');a.href='mailto:'+m[0];a.textContent=m[0];a2.parentNode.replaceChild(a,a2);t=rest;}});
  }
  function init(){
    wrapText(document.body);wrapEmails(document.body);
    document.addEventListener('click',function(e){
      var el=e.target.closest&&e.target.closest('[data-open-chat],[data-ctf-open-chat],a[href="#chat"],a[href$="/#chat"]');
      if(el)openChat(e);
    },true);
    if(location.hash==='#chat')openChat();
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
})();
